import { ADD_QUEUES, GETQUEUES, GET_FILTERED_QUEUE_PROJECTS, SET_ALL_QUEUE_PROJECTS } from "../../actions/action-types";
import { setEmptyStream, setIsLastStream, setNewProject, storeEmojiIcons, storeProjectStreams, storeTotalDraftStreams } from "../../actions/projects";
import { updateAllQueues } from "../../actions/queue";
import { setTeamSidebarDetails } from "../../actions/teamSidebar";
import { AUTH_TOKENS, notifyIcon, number, requestMethod } from "../../config/";
import config from "../../env.config";
import { checkApiSuccess } from "../../utils/";
import { getNotification } from "../../utils/common";
import { fetch } from "./api.service";
import { getAddQueuePayload, getDefaultProjectPayload } from "./service.helper";
import { loadState } from "./session.service";

/**
 * handling api for adding queue
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const addQueue = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/queue/addNewQueue`,
      data: data,
    };
    const ownersLength = data?.owners.split(",").length;
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      const newWorkspace = getAddQueuePayload(data, response);
      await dispatch(addQueueAction(newWorkspace));
      const payload = getDefaultProjectPayload(response, data, ownersLength);
      await dispatch(setNewProject(payload));
      return response.data.data;
    } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
  };
};

/**
 * handling api for getting all queues
 * @returns {void}
 * @author Prachi Jain
 */

export const getAllQueues = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/queue/getAllQueues`,
      params: {
        ...(payload && { isAdmin: true }),
        ...(payload?.companyId && { companyId: payload.companyId }),
      },
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeQueues(response.data.data));
      return response.data.data;
    }
  };
};

/**
 * saving the queues in redux store
 * @param {*} queues
 * @returns {type Of Action}
 * @returns {list of queues to set}
 */

export const storeQueues = (queues) => {
  return {
    type: GETQUEUES,
    payload: queues,
  };
};

/**
 * handling api for updating queue
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const updateQueue = (data) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/queue/updateQueue`,
      data: data,
    };
    var user = loadState(AUTH_TOKENS.USER);
    const state = getState();
    const assigneeList = state.tasks?.defaultDetails.assigneeList;
    const ownersNames = assigneeList
      ?.filter((assignee) => data?.owners?.includes(assignee?.value.toString()))
      ?.map((assignee) => assignee?.value)
      .join(",");
    const icon = state.tasks.defaultDetails?.privacyStatus?.find((privacy) => privacy?.PrivacyId === number.TWO)?.Icon;
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const firstOwnerId = data?.owners?.[0];
      const firstOwner = assigneeList?.find((a) => a?.value?.toString() === firstOwnerId?.toString());
      const payload = {
        QueueId: data.queueId,
        Privacy: number.TWO,
        queuePrivacyIcon: icon,
        Name: data?.owners?.length ? (firstOwner?.label ?? user?.name) : user?.name,
        ...(data?.queueName && { QueueName: data?.queueName }),
        ...(data?.owners && { owners: ownersNames }),
      };
      dispatch(updateAllQueues(payload));
    }
    getNotification(response?.data?.message, response?.data?.data ? notifyIcon.SUCCESS_ICON : notifyIcon.ERROR_ICON);
  };
};

export const storeAllQueueProjects = (queues) => {
  return {
    type: SET_ALL_QUEUE_PROJECTS,
    payload: queues,
  };
};

/**
 * saving the fitered projects of queue in redux store
 * @param {*} projects
 * @returns {type Of Action}
 * @returns {list of queues to set}
 */

export const storeFilteredQueueProjects = (text) => {
  return {
    type: GET_FILTERED_QUEUE_PROJECTS,
    text: text,
  };
};

/**
 * handling api for updating queue
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const updateProjectQueue = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/queue/updateProjectQueue`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/**
 * used to add queues in the redux
 * @param {object} payload
 * @returns {object}
 * @author Sejal
 */
export const addQueueAction = (payload) => {
  return {
    type: ADD_QUEUES,
    payload: payload,
  };
};

/**
 * used to add default project in the redux for state management
 *@param {object} payload
 * @returns {object}
 * @author Sejal
 */
export const addDefaultProject = (payload) => {
  return {
    type: ADD_DEFAULT_PROJECT,
    payload: payload,
  };
};

export const getQueueStream = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/queue/getQueueStream`,
        params: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data?.stream?.length) {
        dispatch(storeProjectStreams(response.data.data.stream));
      } else {
        dispatch(setIsLastStream(true));
        dispatch(setEmptyStream(true));
      }
      dispatch(storeEmojiIcons(response.data.data.emojiList));
      dispatch(storeTotalDraftStreams(response.data.data.totalDraftStreams));
    }
    return response?.data?.data;
  };
};

/**
 * handling api for updating team sidebar details
 * @param {data}
 * @returns {void}
 */
export const getTeamSideBarDetails = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/queue/getQueueDetails`,
        params: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(setTeamSidebarDetails(response.data.data));
    }
    return response?.data?.data;
  };
};

// used to delete the empty workspace
export const deleteWorkspace = (payload) => {
  return async (dispatch, getState) => {
    const requestConfig = {
        method: requestMethod.DELETE,
        url: `${config.BASE_URL.BASE_API_URL}/queue/deleteWorkspace`,
        data: { userId: payload.user.id, queueId: payload.queueId },
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const allQueues = getState()?.allQueues;
      const updatedQueues = allQueues?.filter((item) => item.QueueId != payload.queueId);
      dispatch(storeQueues(updatedQueues));
      getNotification(`${response.data.message}`, notifyIcon.SUCCESS_ICON);

      return response.data.message;
    } else if (response) {
      getNotification(response.data.message, notifyIcon.ERROR_ICON);
    }
  };
};

export const getQueuesAllProjects = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/queue/getQueuesAllProjects`,
        params: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeAllQueueProjects(response.data.data));
    }
    return response?.data?.data;
  };
};
